// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Radio = require("@mui/material/Radio").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;
var Divider = require("@mui/material/Divider").default;
var MM_wrk_frag_transform = require("../worker/MM_wrk_frag_transform.bs.js");
var Checkbox = require("@mui/material/Checkbox").default;
var TextField = require("@mui/material/TextField").default;
var Done = require("@mui/icons-material/Done").default;
var IconButton = require("@mui/material/IconButton").default;
var RadioGroup = require("@mui/material/RadioGroup").default;
var Logout = require("@mui/icons-material/Logout").default;
var ArrowBack = require("@mui/icons-material/ArrowBack").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;
var ContentCopy = require("@mui/icons-material/ContentCopy").default;

function MM_cmp_single_frag_transf(props) {
  var onUpdateCurrent = props.onUpdateCurrent;
  var onInsertBelow = props.onInsertBelow;
  var onInsertAbove = props.onInsertAbove;
  var onBack = props.onBack;
  var transform = props.transform;
  var selection = props.selection;
  var match = React.useState(function () {
        
      });
  var setError = match[1];
  var error = match[0];
  var match$1 = React.useState(function () {
        
      });
  var setState = match$1[1];
  var state = match$1[0];
  var match$2 = React.useState(function () {
        
      });
  var setCopiedToClipboard = match$2[1];
  var copiedToClipboard = match$2[0];
  React.useEffect((function () {
          var state = MM_wrk_frag_transform.unsafeFunc("Creating initial state", (function (param) {
                  return Curry._1(transform.createInitialState, {
                              selection: selection
                            });
                }));
          if (state.TAG === /* Ok */0) {
            var state$1 = state._0;
            Curry._1(setState, (function (param) {
                    return Caml_option.some(state$1);
                  }));
          } else {
            var msg = state._0;
            Curry._1(setError, (function (param) {
                    return msg;
                  }));
          }
        }), []);
  var rndCustomElem = function (elem) {
    if (!MM_wrk_frag_transform.isObject(elem)) {
      Js_exn.raiseError("Each component must be an object");
    }
    var componentName = MM_wrk_frag_transform.reqStrExn(elem.cmp, "Each component must have a string attribute 'cmp' which specifies component name");
    switch (componentName) {
      case "ApplyButtons" :
          var elem$1 = MM_wrk_frag_transform.objToObj(elem);
          var result = Common.getSpaceSeparatedValuesAsArray(MM_wrk_frag_transform.reqStrExn(elem$1.result, "Each ApplyButtons component must have a string attribute 'result'")).join(" ");
          return React.createElement(Expln_React_Column.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(Expln_React_Row.make, {
                          children: Caml_option.some(null)
                        }, React.createElement(IconButton, {
                              onClick: (function (param) {
                                  Curry._1(onBack, undefined);
                                }),
                              color: "primary",
                              title: "Back",
                              children: Caml_option.some(React.createElement(ArrowBack, {}))
                            }), React.createElement(IconButton, {
                              onClick: (function (param) {
                                  Expln_utils_promise.promiseMap(MM_react_common.copyToClipboard(result), (function (param) {
                                          Curry._1(setCopiedToClipboard, (function (timerId) {
                                                  if (timerId !== undefined) {
                                                    Common.$$clearTimeout(Caml_option.valFromOption(timerId));
                                                  }
                                                  return Caml_option.some(Common.$$setTimeout((function (param) {
                                                                    Curry._1(setCopiedToClipboard, (function (param) {
                                                                            
                                                                          }));
                                                                  }), 1000));
                                                }));
                                        }));
                                }),
                              color: "primary",
                              title: "Copy to the clipboard",
                              children: Caml_option.some(React.createElement(ContentCopy, {}))
                            }), React.createElement(IconButton, {
                              onClick: (function (param) {
                                  Curry._1(onInsertAbove, result);
                                }),
                              color: "primary",
                              title: "Add new step above",
                              children: Caml_option.some(React.createElement(Logout, {
                                        style: {
                                          transform: "rotate(-90deg)"
                                        }
                                      }))
                            }), React.createElement(IconButton, {
                              onClick: (function (param) {
                                  Curry._1(onInsertBelow, result);
                                }),
                              color: "primary",
                              title: "Add new step below",
                              children: Caml_option.some(React.createElement(Logout, {
                                        style: {
                                          transform: "rotate(90deg)"
                                        }
                                      }))
                            }), React.createElement(IconButton, {
                              onClick: (function (param) {
                                  Curry._1(onUpdateCurrent, result);
                                }),
                              color: "primary",
                              title: "Update current step",
                              children: Caml_option.some(React.createElement(Done, {}))
                            })), Belt_Option.isSome(copiedToClipboard) ? "Copied to the clipboard." : null);
      case "Checkbox" :
          var elem$2 = MM_wrk_frag_transform.objToObj(elem);
          var checked = MM_wrk_frag_transform.reqBoolExn(elem$2.checked, "Each Checkbox must have a boolean attribute 'checked'");
          var disabled = MM_wrk_frag_transform.optBoolExn(elem$2.disabled, "optional 'disabled' attribute of a Checkbox must be a boolean");
          var onChange = MM_wrk_frag_transform.reqFuncExn(elem$2.onChange, "Each Checkbox must have an attribute 'onChange' of type boolean => void");
          return React.createElement(FormControlLabel, {
                      control: React.createElement(Checkbox, {
                            disabled: disabled,
                            checked: checked,
                            onChange: (function (param) {
                                return Expln_React_common.evt2bool((function (b) {
                                              onChange(b);
                                            }), param);
                              })
                          }),
                      label: MM_wrk_frag_transform.reqStrExn(elem$2.label, "Each Checkbox must have a string attribute 'label'")
                    });
      case "Col" :
          var elem$3 = MM_wrk_frag_transform.objToObj(elem);
          var msg = "Each 'Col' component must have a 'children' attribute which holds an array of components comprising the content of this 'Col' component";
          return React.createElement(Expln_React_Column.make, {
                      children: Caml_option.some(childrenToArray(MM_wrk_frag_transform.reqArrExn(elem$3.children, msg), msg))
                    });
      case "Divider" :
          return React.createElement(Divider, {});
      case "RadioGroup" :
          var elem$4 = MM_wrk_frag_transform.objToObj(elem);
          var row = MM_wrk_frag_transform.reqBoolExn(elem$4.row, "Each RadioGroup must have a boolean attribute 'row'");
          var value = MM_wrk_frag_transform.reqStrExn(elem$4.value, "Each RadioGroup must have a string attribute 'value'");
          var disabled$1 = MM_wrk_frag_transform.optBoolExn(elem$4.disabled, "optional 'disabled' attribute of a RadioGroup must be a boolean");
          var onChange$1 = MM_wrk_frag_transform.reqFuncExn(elem$4.onChange, "Each RadioGroup must have an attribute 'onChange' of type string => void");
          var options = MM_wrk_frag_transform.reqArrExn(elem$4.options, "Each RadioGroup must have an array attribute 'options' of type array<[value:string,label:string]>");
          return React.createElement(RadioGroup, {
                      value: value,
                      onChange: (function (param) {
                          return Expln_React_common.evt2str((function (str) {
                                        onChange$1(str);
                                      }), param);
                        }),
                      row: row,
                      children: Caml_option.some(options.map(function (option) {
                                var value = Caml_array.get(option, 0);
                                var label = Caml_array.get(option, 1);
                                return JsxPPXReactSupport.createElementWithKey(value, FormControlLabel, {
                                            control: React.createElement(Radio, {}),
                                            label: label,
                                            disabled: disabled$1,
                                            style: {
                                              marginRight: "30px"
                                            },
                                            value: value
                                          });
                              }))
                    });
      case "Row" :
          var elem$5 = MM_wrk_frag_transform.objToObj(elem);
          var msg$1 = "Each 'Row' component must have a 'children' attribute which holds an array of components comprising the content of this 'Row' component";
          return React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(childrenToArray(MM_wrk_frag_transform.reqArrExn(elem$5.children, msg$1), msg$1))
                    });
      case "Text" :
          var elem$6 = MM_wrk_frag_transform.objToObj(elem);
          var tmp = {};
          var tmp$1 = MM_wrk_frag_transform.optStrExn(elem$6.backgroundColor, "optional 'backgroundColor' attribute of a 'Text' component must be a string");
          if (tmp$1 !== undefined) {
            tmp.backgroundColor = tmp$1;
          }
          var tmp$2 = MM_wrk_frag_transform.optStrExn(elem$6.fontWeight, "optional 'fontWeight' attribute of a 'Text' component must be a string");
          if (tmp$2 !== undefined) {
            tmp.fontWeight = tmp$2;
          }
          return React.createElement("span", {
                      style: tmp
                    }, MM_wrk_frag_transform.reqStrExn(elem$6.value, "Each Text component must have a string attribute 'value'"));
      case "TextField" :
          var elem$7 = MM_wrk_frag_transform.objToObj(elem);
          var onChange$2 = MM_wrk_frag_transform.reqFuncExn(elem$7.onChange, "Each TextField must have an attribute 'onChange' of type string => void");
          var tmp$3 = {};
          var tmp$4 = MM_wrk_frag_transform.optStrExn(elem$7.width, "optional 'width' attribute of a TextField must be a string");
          if (tmp$4 !== undefined) {
            tmp$3.width = tmp$4;
          }
          return React.createElement(TextField, {
                      value: MM_wrk_frag_transform.reqStrExn(elem$7.value, "Each TextField must have a string attribute 'value'"),
                      label: MM_wrk_frag_transform.reqStrExn(elem$7.label, "Each TextField must have a string attribute 'label'"),
                      size: "small",
                      style: tmp$3,
                      onChange: (function (param) {
                          return Expln_React_common.evt2str((function (str) {
                                        onChange$2(str);
                                      }), param);
                        }),
                      autoFocus: MM_wrk_frag_transform.optBoolExn(elem$7.autoFocus, "optional 'autoFocus' attribute of a TextField must be a boolean")
                    });
      case "span" :
          var elem$8 = MM_wrk_frag_transform.objToObj(elem);
          var msg$2 = "Each 'span' component must have a 'children' attribute which holds an array of components comprising the content of this 'span' component";
          return React.createElement("span", undefined, childrenToArray(MM_wrk_frag_transform.reqArrExn(elem$8.children, msg$2), msg$2));
      default:
        return Js_exn.raiseError("Unrecognized component '" + componentName + "'");
    }
  };
  var childrenToArray = function (children, msg) {
    return children.filter(function (child) {
                  return Belt_Option.isSome((child == null) ? undefined : Caml_option.some(child));
                }).map(function (child, i) {
                var child$1 = MM_wrk_frag_transform.reqObjExn(child, "A child element is not a component object: " + msg + "");
                return React.cloneElement(rndCustomElem(child$1), {
                            key: Belt_Option.getWithDefault(MM_wrk_frag_transform.optStrExn(child$1.key, "optional 'key' attribute of any component must be a string"), String(i))
                          });
              });
  };
  if (error !== undefined) {
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, "Error: " + error + "", React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(onBack, undefined);
                      }),
                    title: "Back",
                    children: Caml_option.some(React.createElement(ArrowBack, {}))
                  }));
  } else if (state !== undefined) {
    var state$1 = Caml_option.valFromOption(state);
    var params = {
      selection: selection,
      state: state$1,
      setState: (function (mapper) {
          Curry._1(setState, (function (__x) {
                  return Belt_Option.map(__x, mapper);
                }));
        })
    };
    var reElemDto = MM_wrk_frag_transform.unsafeFunc("Rendering dialog (getting a DTO)", (function (param) {
            return Curry._1(transform.renderDialog, params);
          }));
    if (reElemDto.TAG === /* Ok */0) {
      var reElemDto$1 = reElemDto._0;
      var customElem = MM_wrk_frag_transform.unsafeFunc("Rendering dialog (rendering a DTO)", (function (param) {
              return rndCustomElem(MM_wrk_frag_transform.reactElemDtoToObj(reElemDto$1));
            }));
      if (customElem.TAG === /* Ok */0) {
        return customElem._0;
      }
      var msg = customElem._0;
      Curry._1(setError, (function (param) {
              return msg;
            }));
      return null;
    }
    var msg$1 = reElemDto._0;
    Curry._1(setError, (function (param) {
            return msg$1;
          }));
    return null;
  } else {
    return React.createElement(Expln_React_Column.make, {
                spacing: 1,
                children: Caml_option.some(null)
              }, "Initializing...", React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(onBack, undefined);
                      }),
                    variant: "outlined",
                    children: "Cancel"
                  }));
  }
}

var make = MM_cmp_single_frag_transf;

exports.make = make;
/* react Not a pure module */
